import { apiSlice } from "../app/api/apiSlice";

export const employeeShiftLogsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllUserShifts: builder.query({
            query: ({user_id,pagination,start_date,end_date,employee_id}) => `user/user-shifts/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['EmoployeeShiftsLogs']
        }),

        getAllDateRangeUserShifts: builder.mutation({
            query: ({user_id,pagination,start_date,end_date,employee_id,page}) => `user/user-shifts/${user_id}/${pagination}/${start_date}/${end_date}/${employee_id}?page=${page}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['EmoployeeShiftsLogs']
        }),

        getShiftById: builder.mutation({
            query: (shift_id) => `user/employee-shifts/${shift_id}`,
            transformResponse: responseData => {
                return responseData;
            },
            providesTags: ['EmoployeeShiftsLogs']
        }),
    })
})

export const {
    useGetAllUserShiftsQuery,
    useGetAllDateRangeUserShiftsMutation,
    useGetShiftByIdMutation,    
} = employeeShiftLogsSlice

